import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import AssessmentPlanRequests from "./assessmentPlanRequests/AssessmentPlanRequests"
import WorkProgramRequests from "./workProgramRequests/WorkProgramList"
import "../../../../src/styles/userManagement.css";
import LoaderScreen from '../../Common/loaderScreen'
import displayToastMessage from "../../../components/Common/Alert/displayToastMessage";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";

function Manager() {

  const [currentTab, setCurrentTab] = useState("1");
  const [reset, setReset] = useState(false);
  const [requests, setRequests] = useState([]);
  const [workPrograms, setWorkPrograms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoader, setDataLoader] = useState(false)
  const { sendRequest: getPlanRequests } = useHttp();
  const { sendRequest: getWorkPrograms } = useHttp();
  const handleTabs = (e, v) => {
    setCurrentTab(v);
    setReset(!reset)
  };

  const getVRequest = async () => {
    setDataLoader(true)
    getPlanRequests(APIService.getPlanRequests(), (result) => {
      setRequests(result.MSG[0])
    }, errorHandler)
    setDataLoader(false)
  };

  const errorHandler = () => {
    displayToastMessage("Something went wrong, Please try again!", "error");
  }

  const getWPRequest = async () => {
    setDataLoader(true)
    getWorkPrograms(APIService.getWorkPrograms(), (data) => {
      setWorkPrograms(data.MSG[0])
    })
    setDataLoader(false)
  };

  const handleDelete = async (vendorId, userId) => {
    setLoading(true);
    
  };

  const handleWpDelete = async (wpId, userId) => {
    setLoading(true);
   
  };
  
  useEffect(() => {
    getVRequest();
    getWPRequest();
  }, []);

  return (
    <div className="user-management-container">
      <Tabs
        defaultValue={currentTab}
        value={currentTab}
        onChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="1" label="Plan Requests">
          {dataLoader ?
            <LoaderScreen />
            :
            <AssessmentPlanRequests exitEdit={reset} vendorData={requests} 
            // handleDelete={handleDelete} 
            getVRequest={getVRequest} />
          }</Tab>
          <Tab value="2" label="Work Program Requests">
          <WorkProgramRequests exitEdit={reset} workProgramData={workPrograms} 
          // handleWpDelete={handleWpDelete} 
          getWPRequest={getWPRequest} />
        </Tab>
      </Tabs>
    </div>

  );
}
export default Manager;
